import { Pencil, Trash2 } from 'lucide-react';
import type { Integration } from '../../types/integration';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Badge,
} from '../ui';

interface IntegrationListProps {
  integrations: Integration[];
  onEdit: (integration: Integration) => void;
  onDelete: (integration: Integration) => void;
}

const INTEGRATION_URL_FIELDS: { label: string; field: keyof Integration }[] = [
  { label: 'IXC', field: 'ixc_url' },
  { label: 'Whaticket', field: 'ticketz_url' },
  { label: 'Gammu', field: 'gammu_user' },
  { label: 'Digisac', field: 'digisac_url' },
  { label: 'SGP', field: 'sgp_url' },
  { label: 'Hubsoft', field: 'hubsoft_url' },
  { label: 'MediaWiki', field: 'mediawiki_url' },
  { label: 'OPA', field: 'opa_url' },
  { label: 'Fortics', field: 'fortics_url' },
  { label: 'Asaas', field: 'asaas_url' },
  { label: 'Genérica', field: 'generic_url' },
];

function getFilledIntegrations(integration: Integration): string[] {
  return INTEGRATION_URL_FIELDS.filter(({ field }) => integration[field]).map(({ label }) => label);
}

function IntegrationList({ integrations, onEdit, onDelete }: IntegrationListProps) {
  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Descrição</TableHead>
            <TableHead>Integrações</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {integrations.map(integration => {
            const filled = getFilledIntegrations(integration);
            return (
              <TableRow key={integration.id}>
                <TableCell>{integration.id}</TableCell>
                <TableCell>{integration.description}</TableCell>
                <TableCell>
                  {filled.length > 0 ? (
                    <div className="flex flex-wrap gap-1">
                      {filled.map(label => (
                        <Badge key={label} variant="info">
                          {label}
                        </Badge>
                      ))}
                    </div>
                  ) : (
                    <span className="text-sm text-gray-400">Nenhuma</span>
                  )}
                </TableCell>
                <TableCell className="text-right space-x-2">
                  <Button variant="ghost" onClick={() => onEdit(integration)} title="Editar">
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" onClick={() => onDelete(integration)} title="Excluir">
                    <Trash2 className="h-4 w-4 text-red-600" />
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default IntegrationList;
